import { observable, action } from 'mobx';
import moment, { type Moment } from 'moment';
import { AccelFile, Entity } from '..';

export class RegistrationConsent extends Entity {
    @observable consentText: string;
    @observable consentFileId?: string | null;
    @observable consentUrl?: string | null;
    @observable sortOrder: number;
    @observable isActive: boolean;
    @observable isDeleted: boolean;
    @observable version?: string;
    @observable createdDate?: Moment;
    @observable updatedDate?: Moment;
    @observable createdByAdminId?: string;
    @observable updatedByAdminId?: string;
    @observable required?: boolean;
    @observable file?: AccelFile | null;

    constructor(consent?: Partial<RegistrationConsent>) {
        super(consent);
        if (consent) this.update(consent);
    }

    @action update(consent: Partial<RegistrationConsent>, allowUndefined = false) {
        super.update(consent, allowUndefined);
    }

    copy() {
        return new RegistrationConsent({
            ...this,
            createdDate: this.createdDate ? moment(this.createdDate) : undefined,
            updatedDate: this.updatedDate ? moment(this.updatedDate) : undefined,
            file: this.file ? this.file.clone() : null
        });
    }

    static fromJson(json: any): RegistrationConsent {
        const file = json.file ? AccelFile.fromJson(json.file) : null;       
        if (file && json.consentFileId) {
            file.update({ id: json.consentFileId });
        }
        return new RegistrationConsent({
            ...json,
            createdDate: json.createdDate ? moment(json.createdDate) : undefined,
            updatedDate: json.updatedDate ? moment(json.updatedDate) : undefined,
            file: file
        });
    }
}

export type RegistrationConsentPatch = {
    id?: string;
    consentText?: string;
    consentUrl?: string | null;
    consentFileId?: string | null;
    isActive?: boolean;
    sortOrder?: number;
    version?: string;
};

export type RegistrationConsentDraft = RegistrationConsentPatch & {
    tempId: string;
    file?: AccelFile | null;
    isDeleted?: boolean;
    createdDate?: Moment;
    updatedDate?: Moment;
    createdByAdminId?: string;
    updatedByAdminId?: string;
    required?: boolean;
};

